import { FeatureFlag } from '@sonar-software/sonar-core';
import { SonarText } from '@ui/text';
import { useFeatureFlag } from '@hooks';

import { Else, If, Then } from 'react-if';
import React, { PropsWithChildren, ReactNode } from 'react';

interface TimelineFilterSectionProps {
	title?: string | ReactNode;
	featureFlag?: FeatureFlag;
	hidden?: boolean;
}

export const TimelineFilterSection: React.FC<PropsWithChildren<TimelineFilterSectionProps>> = ({
	children,
	featureFlag,
	hidden,
	title
}) => {
	const isEnabled = useFeatureFlag(featureFlag, true);

	if (!children) {
		return null;
	}

	if (!isEnabled || hidden) {
		return null;
	}

	return (
		<div className='timeline-filter-section'>
			<If condition={ typeof title === 'string' }>
				<Then>
					<SonarText className='h3'>{ title }</SonarText>
				</Then>
				<Else>
					{ title }
				</Else>
			</If>
			{ children }
		</div>
	);
};
